import createCache from '@emotion/cache';
import { getCspNonce } from './csp';

/**
 * Create an Emotion cache with CSP nonce support
 * This allows Material-UI styles to be compatible with Content Security Policy
 *
 * Usage in your app:
 * Wrap your app with CacheProvider and pass the cache created by this function
 */
export function createEmotionCache() {
  const nonce = getCspNonce();

  return createCache({
    key: 'css',
    prepend: true,
    nonce,
  });
}
